import {environment} from '../../../environments/environment';

export const getStoredApiUrl = (defaultUrl: string): string => {
  if (typeof window !== 'undefined' && window.localStorage) {
    const stored = localStorage.getItem('apiUrl');
    if (stored) {
      return stored;
    }
  }
  return defaultUrl;
};

export function updateApiUrl(url: string) {
  environment.apiUrl = url;
  if (typeof window !== 'undefined' && window.localStorage) {
    localStorage.setItem('apiUrl', url);
  }
}
